<app-header [isScrolled]="true"></app-header>
<ion-content [lang]="languageService.lang()"
             [dir]="languageService.dir()">
  <section class="inner-banner">
    <div class="banner-overlay">
      <div class="content-wrapper banner-content flex align-items-center">
        <div class="banner-text">
          <h1>{{ assetProperty?.pageTitle }}</h1>
        </div>
      </div>
    </div>
  </section>

  <article class="article">

    @for (content of assetProperty?.contentList; track content; let i = $index) {
      <ion-row class="ion-align-items-center" [class.flex-reverse]="i % 2 !== 0">
        <ion-col size="12" size-lg="6">
          <ion-img src="assets/inner/about-inner-1-min.png" alt="Asset and property management"></ion-img>
        </ion-col>
        <ion-col size="12" size-lg="6">
          <h2>{{ content?.title }}</h2>
          <p>{{ content?.text }}</p>
        </ion-col>
      </ion-row>
    }

    <ion-row>
      <ion-col size-lg="6" size="12">
<!--        <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Cras convallis magna ac purus mollis iaculis. Suspendisse potenti. Donec sed malesuada turpis, non laoreet libero. Integer vestibulum efficitur efficitur. Etiam gravida nibh ligula, sed consequat libero tincidunt et. Suspendisse egestas quis mauris sed feugiat.</p>-->
      </ion-col>
      <ion-col size-lg="6" size="12">
        <app-contact-form></app-contact-form>
      </ion-col>
    </ion-row>

  </article>

  <app-footer></app-footer>
</ion-content>
